import React from "react"

import CopyButton from "~components/CopyButton"

import * as style from "./UrlBar.module.scss"

const UrlBar = ({ endpoint }) => (
  <div className={style.urlbar}>
    <div data-verb={endpoint.verb}>{endpoint.verb}</div>
    <div data-url>
      <div data-server>{endpoint.server.url}</div>
      <div data-path>
        {endpoint.apiPath.split(/[{}]/g).map((part, index) => {
          if (part && index % 2) {
            return (
              <strong key={index}>
                :
                {part}
              </strong>
            )
          } else if (part) {
            return <span key={index}>{part}</span>
          }
        })}
      </div>
    </div>
    <div data-copy>
      <CopyButton text={endpoint.apiPath} />
    </div>
  </div>
)

export default UrlBar
